import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { BrowserRouter } from "react-router-dom";
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://752cd61ed64c2505ddbca528626e26d5@o4509237300756480.ingest.de.sentry.io/4509238280192080",
  sendDefaultPii: true,
  enabled: import.meta.env.VITE_API_URL !== "http://localhost:9000",

  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.httpClientIntegration(),
  ],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
  // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
  // pour les requêtes vers le backend qui commencent par /common, /practitioner, /patient, /dashboard
  tracePropagationTargets: [
    import.meta.env.VITE_API_URL,
    "/common",
    "/practitioner",
    "/patient",
    "/dashboard",
  ],
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);